import GameLeaderboard from './GameLeaderboard';
export default GameLeaderboard;
